import { __decorate, __metadata } from "tslib";
import { Expose, Transform } from 'class-transformer';
import { ObjectId } from 'mongodb';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { FixtureNonPersistentCartDto } from './FixtureNonPersistentCartDto';
let FixtureCartDto = class FixtureCartDto extends FixtureNonPersistentCartDto {
};
__decorate([
    Expose({ groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ] }),
    Transform((params) => params.value.toString(), { toPlainOnly: true }),
    __metadata("design:type", ObjectId)
], FixtureCartDto.prototype, "_id", void 0);
__decorate([
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.READ] }),
    __metadata("design:type", Date)
], FixtureCartDto.prototype, "updated_at", void 0);
__decorate([
    Expose({ groups: [CartExposeGroup.FIXTURE, OrderExposeGroup.FIXTURE, CartExposeGroup.READ, OrderExposeGroup.READ] }),
    __metadata("design:type", Date)
], FixtureCartDto.prototype, "created_at", void 0);
FixtureCartDto = __decorate([
    Expose({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] })
], FixtureCartDto);
export { FixtureCartDto };
//# sourceMappingURL=FixtureCartDto.js.map